<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex xs8 offset-xs2>
        <v-container grid-list-xl fluid>
          <v-layout row wrap>
            <v-flex xs12>
              <h1 class="display-1">Postcode Management</h1>
            </v-flex>
            <v-flex xs6>
              <v-card>
                <v-container grid-list-xl fluid>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <h2 class="headline">Add Postcode</h2>
                      <v-text-field label="Postcode" v-model="postcode"></v-text-field>
                      <v-text-field label="Location" v-model="name"></v-text-field>
                      <v-text-field label="Shutter Price PSQM" v-model="shutterPSQM"></v-text-field>
                      <v-checkbox label="Install Shutters?" v-model="installShutter"></v-checkbox>
                      <v-checkbox label="Install Roller Blinds?" v-model="installRollerBlind"></v-checkbox>
                      <v-checkbox label="Install Curtains?" v-model="installCurtain"></v-checkbox>
                      <v-btn large color="primary" @click="addPostcode">Add Postcode</v-btn>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card>
            </v-flex>

            <v-flex xs6>
              <v-card>
                <v-container grid-list-xl fluid>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-data-table :headers="headers" :items="postcodes">
                        <template slot="items" slot-scope="props">
                          <td>{{ props.item.postcode }}</td>
                          <td>{{ props.item.name }}</td>
                          <td>{{ props.item.shutterPrice.toFixed(2) }}</td>
                          <td>{{ props.item.installShutter }}</td>
                          <td>{{ props.item.installRollerBlind }}</td>
                          <td>{{ props.item.installCurtain }}</td>
                          <td>
                            <button @click="deletePostcode(props.item._id)">Delete</button>
                          </td>
                        </template>
                    </v-data-table>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import PostcodeService from '@/services/PostcodeService.js'
export default {
  data () {
    return {
      headers: [
        { text: 'Postcode', value: 'postcode' },
        { text: 'Location', value: 'location' },
        { text: 'Shutter Price PSQM', value: 'shutterPricePSQM' },
        { text: 'Shutter Install', value: 'shutterInstall' },
        { text: 'Roller Blind Install', value: 'rollerBlindInstall' },
        { text: 'Curtain Install', value: 'curtainInstall' },
        { text: 'Actions', value: 'actions' }
      ],
      postcodes: [],
      postcode: null,
      name: null,
      shutterPSQM: null,
      installShutter: null,
      installRollerBlind: null,
      installCurtain: null
    }
  },
  mounted () {
    this.getPostcodes()
  },
  methods: {
    async getPostcodes () {
      const response = await PostcodeService.getPostcodes()
      this.postcodes = response.data.postcodes
    },

    async addPostcode () {
      await PostcodeService.addPostcode({
        postcode: this.postcode,
        name: this.name,
        shutterPrice: this.shutterPSQM,
        installShutter: this.installShutter,
        installRollerBlind: this.installRollerBlind,
        installCurtain: this.installCurtain
      })

      this.postcode = null
      this.name = null
      this.shutterPSQM = null
      this.installShutter = null
      this.installRollerBlind = null
      this.installCurtain = null

      this.getPostcodes()
    },

    async deletePostcode (id) {
      await PostcodeService.deletePostcode(id)

      this.getPostcodes()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/Postcodes.vue